import { useCallback } from 'react'
import { Model } from 'sunlife-domain'

import { useWebComponentProperty$ } from '@salsita-ai/platform-project-sdk/react'

import { webComponentProperties } from '../api/web-component-properties'
import { configuratorInterface } from '../systems/configurator-interface'

export const onPresetLoadedHandler = configuratorInterface.createOnPresetLoadedHandler(() => {
  const shortsSize$ = useWebComponentProperty$(webComponentProperties.shortsSize)
  return {
    handler: useCallback(
      async presetEntities => {
        const size = shortsSize$.value
        if (size === undefined) {
          return presetEntities
        }
        return presetEntities.map(entity => {
          if (Model.Shorts.is(entity)) {
            return {
              ...entity,
              size,
            }
          }
          return entity
        })
      },
      [shortsSize$]
    ),
  }
})
